module.exports = __WEBPACK_EXTERNAL_MODULE_73__;


//////////////////
// WEBPACK FOOTER
// external "ionic-angular"
// module id = 73
// module chunks = 0